__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-02-10-1770705717-stable-dev/";